module.exports = __webpack_public_path__ + "img/17-SHIFT.c1eed951.jpg";